import { useEffect, useState } from "react";
import { Button, MenuItem, TextField } from "@mui/material";

/** Shared form for APIs with named query parameters instead of legacy predicates. */
export default function ControlledFilters({ schema, value, onApply, loading }) {
  const [draft, setDraft] = useState(value);
  useEffect(() => { setDraft(value); }, [value]);
  const change = (name, next) => setDraft((current) => ({ ...current, [name]: next }));
  const invalid = schema.some((field) => field.after && draft[field.name] && draft[field.after]
    && draft[field.name] < draft[field.after]);
  return <form className="flex flex-wrap items-center gap-2 mb-4" onSubmit={(event) => {
    event.preventDefault(); if (!loading && !invalid) onApply({ ...draft, page: 1 });
  }}>
    {schema.map((field) => <TextField key={field.name} size="small" className="sm:w-[11.25rem] w-full"
      label={field.title} select={field.type === "enum"} type={field.type === "date" ? "date" : "text"}
      value={draft[field.name] ?? ""} onChange={(event) => change(field.name, event.target.value)}
      InputLabelProps={field.type === "date" ? { shrink: true } : undefined}
      inputProps={{ maxLength: field.maxLength, min: field.after ? draft[field.after] || undefined : undefined }}>
      {field.type === "enum" ? [<MenuItem key="all" value="">{field.emptyTitle || "همه"}</MenuItem>,
        ...field.options.map((option) => <MenuItem key={option.value} value={option.value}>{option.title}</MenuItem>)] : null}
    </TextField>)}
    <Button type="submit" variant="contained" disabled={loading || invalid}>اعمال فیلتر</Button>
    <Button type="button" color="success" variant="contained" disabled={loading} onClick={() => {
      const clean = { ...value, page: 1 };
      schema.forEach((field) => { clean[field.name] = ""; });
      setDraft(clean); onApply(clean);
    }}>پاک‌کردن فیلتر</Button>
  </form>;
}
